import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { InfoLine } from '../InfoSection';
export const isNil = (value) => value == null;
// TODO: review this logic, left untouched from Comments.tsx
export const FooterNotes = ({ footer, metaData, t }) => {
    const { notes, legalTerms } = metaData ?? {};
    const { firstLabel, secondLabel } = footer ?? {};
    const formattedNotes = ReactHtmlParser(notes);
    const formattedLegalTerms = ReactHtmlParser(legalTerms);
    const showNotesSection = firstLabel || notes;
    const showLegalTermsSection = secondLabel || legalTerms;
    const firstLabelIfNeeded = () => {
        if (!notes) {
            return null;
        }
        else if (isNil(firstLabel)) {
            return t('price-quote.view.notes');
        }
        return firstLabel ?? null;
    };
    const secondLabelIfNeeded = () => {
        if (!legalTerms) {
            return null;
        }
        else if (isNil(secondLabel)) {
            return t('price-quote.view.legal-terms');
        }
        return secondLabel ?? null;
    };
    const renderFooterSection = (label, content) => (React.createElement(React.Fragment, null,
        React.createElement(InfoLine, { type: "subtext", weight: "bold", paddingTop: "20px" }, label),
        React.createElement(InfoLine, { type: "subtext", listStyle: "circle", paddingTop: "8px" }, content)));
    if (!notes && !legalTerms) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        showNotesSection &&
            renderFooterSection(firstLabelIfNeeded(), notes ? formattedNotes : null),
        showLegalTermsSection &&
            renderFooterSection(secondLabelIfNeeded(), legalTerms ? formattedLegalTerms : null)));
};
//# sourceMappingURL=FooterNotes.js.map